// CalendlyEmbed.js
import React from "react";
import { Helmet } from "react-helmet";

const CalendlyEmbed = () => {
  return (
    <div>
      <Helmet>
        {/* Calendly Widget Script */}
        <script
          type="text/javascript"
          src="https://assets.calendly.com/assets/external/widget.js"
          async
        ></script>
      </Helmet>

      {/* Calendly Inline Widget */}
      <div
        className="calendly-inline-widget"
        data-url="https://calendly.com/pristineacademicconsultancy/meeting?primary_color=1d74f1"
        style={{ minWidth: "320px", height: "700px" }}
      ></div>
    </div>
  );
};

export default CalendlyEmbed;
